import axios from "../utils/axios";

export const getEqGetMainListByAreaID = (payload) => {
    return axios.get(`/Equipment/GetMainListByAreaID?areaId=${payload}`);
};

export const getEqGetSubListById = (payload) => {
    return axios.get(`/Equipment/GetSubListById?equipmentId=${payload}`);
};

export const getEqGetByBarcodeContext = (payload) => {
    return axios.get(`/Equipment/GetByBarcodeContext?barcodeContext=${payload}`);
};

export const getEqDetailList = (payload) => {
    return axios.get(`/Equipment/GetDetailedList?AreaId=${payload.areaId}&MachineId=${payload.equipmentId}`);
};

export const getEquipmentFiles = (equipmentId) => {
    return axios.get(`/Equipment/${equipmentId}/Files`, { responseType: "arraybuffer" });
};

export const addEquipmentFiles = (payload) => {
    return axios.post(`/Equipment/${payload.equipmentId}/Files`, payload.data);
};

export const deleteEquipmentFiles = (payload) => {
    return axios.delete(`/Equipment/${payload.equipmentId}/Files`, { data: payload.fileNames });
};

export const deleteEquipment = (payload) => {
    return axios.post(`/Equipment/Delete`, { ...payload });
};

export const getEquipmentDetailById = (payload) => {
    return axios.get(`/Equipment/GetDetailById?id=${payload.id}`);
};

export const getEquipmentReportGroupList = () => {
    return axios.get(`/EquipmentReportGroup/GetList`);
};

export const getEquipmentReportGroupById = (payload) => {
    return axios.get(`/Equipment/GetReportGroupsById?equipmentId=${payload}`);
};

export const editEquipmentGroupInfo = (payload) => {
    return axios.post(`/Equipment/EditGroupInfo?equipmentId=${payload.id}`, payload.data);
};

export const getPlantList = () => {
    return axios.get(`/Plant/GetList`);
};

export const getEqTypeList = () => {
    return axios.get(`/EquipmentType/GetList`);
};

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getCostCenterList = () => {
    return axios.get(`/CostCenter/GetCostCenterList`);
};

export const getEqMainList = (payload) => {
    return axios.get(`/Equipment/GetList?onlyMainEquipments=${payload.isMain}`);
};

export const getEquipmentTypeList = () => {
    return axios.get(`/EquipmentType/GetList`);
};

export const getEditEquipment = (payload) => {
    return axios.post(`/Equipment/Update`, { ...payload });
};

export const getAddEquipment = (payload) => {
    return axios.post(`/Equipment/Add`, { ...payload });
};

export const downloadExcel = () => {
    return axios.get(`/Equipment/ExportToExcel`, { responseType: "blob" });
};
